import { createControllerComponent } from './createControllerComponent';
var IonAlert = createControllerComponent('ion-alert', 'ion-alert-controller');
export default IonAlert;